import { Component } from '@angular/core';

@Component({
    selector: 'app-onboarding-mobile-step',
    templateUrl: './onboarding-mobile-step.component.html',
    styleUrls: ['./onboarding-mobile-step.component.scss'],
})
export class OnboardingMobileStepComponent {}
